import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/device-check/abnormal.png'
import _imports_1 from '@/assets/device-check/success.png'


const _withScopeId = n => (_pushScopeId("data-v-542d6790"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-check" }
const _hoisted_2 = { class: "device-check-container" }
const _hoisted_3 = { class: "container_item container_title" }
const _hoisted_4 = { class: "container_item container_content" }
const _hoisted_5 = { class: "check-area" }
const _hoisted_6 = { class: "check-area-item_icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "check-area-item_content" }
const _hoisted_9 = { class: "check-area_content_text" }
const _hoisted_10 = { class: "check-area-item check-area-item_headset" }
const _hoisted_11 = { class: "check-area-item_icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "check-area-item_content" }
const _hoisted_14 = { class: "check-area_content_text" }
const _hoisted_15 = { class: "check-area-item check-area-item_mike" }
const _hoisted_16 = { class: "check-area-item_icon" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "check-area-item_content" }
const _hoisted_19 = { class: "check-area_content_text" }
const _hoisted_20 = { class: "check-area_item_btns" }
const _hoisted_21 = { class: "play-btn" }
const _hoisted_22 = { class: "play-text" }
const _hoisted_23 = { class: "play-btn" }
const _hoisted_24 = { class: "play-text" }
const _hoisted_25 = { class: "check-area-item check-area-item_error" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-area-item_icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-area-item_content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "check-area_content_text" }, " 设备异常，请联系监考老师,更换到其他设备进行测评。 ")
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "check-area-item check-area-item_error" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-area-item_icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_31 = { class: "check-area-item_content" }
const _hoisted_32 = { class: "check-area_content_text" }
const _hoisted_33 = { class: "check-area_orther" }
const _hoisted_34 = { class: "check-area_orther_headset" }
const _hoisted_35 = { class: "container_item container_footer" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("异常")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("再次检测")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("重新检测设备")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("进入测评")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("返回 ")

import _ from "lodash";
import moment from "moment";
import {
  computed,
  onBeforeUnmount,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "@/store";
import {
  ElSteps,
  ElStep,
  ElButton,
  ElSlider,
  ElIcon,
  ElMessage,
} from "element-plus";
import { CirclePlus, Remove, ArrowLeftBold } from "@element-plus/icons-vue";
import SoundRecorder from "@/utils/sound-recorder";
import { platform } from "@/services/platform";
import { ElLoadingService } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/**
 * 1. 全部重新检测等到全部都检测过了
 * 2. 1.2步不需要重新检测
 * 3. 返回放到外卖呢
 */
const router = useRouter();
const route = useRoute();
const store = useStore();

const steps = reactive([
  {
    id: 1,
    title: "根据提示点击对应区域",
    name: "屏幕检测",
    icon: require("@/assets/device-check/touchPanel.png"),
    description: "点击手指区域",
    audio: new Audio("/audios/check_1_screen.mp3"),
    enableAudio: false,
    isChecked: false,
    success: true,
    canAglinCheck: false,
    errorAglinCheck: true,
  },
  {
    id: 2,
    title: "请戴上耳机根据提示，配合设备检测",
    name: "耳机",
    icon: require("@/assets/device-check/headset.png"),
    description: "戴好耳机，请听正在播放的音乐是否音质良好？并调节合适的音量。",
    audio: new Audio("/audios/check_2_earphone.mp3"),
    audioOpt: {
      loop: true,
    },
    enableAudio: true,
    isChecked: false,
    success: true,
    canAglinCheck: false,
    errorAglinCheck: true,
  },
  {
    id: 3,
    title: "请戴上耳机根据提示，配合设备检测",
    name: "麦克风",
    icon: computed(() => {
      return !isRecording.value
        ? require("@/assets/device-check/mike.png")
        : require("@/assets/device-check/mike.gif");
    }),
    description:
      "请点击录音按钮，然后对着麦克风说出“123456”,说完后，点击播放录音。",
    audio: new Audio("/audios/check_3_microphone.mp3"),
    enableAudio: false,
    isChecked: false,
    success: true,
    canAglinCheck: false,
    errorAglinCheck: true,
  },
]);

const activeStepNum = ref(0);
const activeStep = computed(() => {
  const len = steps.length;
  if (activeStepNum.value <= 0) {
    return steps[0];
  } else if (activeStepNum.value >= len) {
    return steps[len - 1];
  }
  return steps[activeStepNum.value];
});

const checkError = computed(() => {
  return steps.filter((s) => !s.success).length > 0;
});

const allChecked = computed(() => {
  return steps.filter((s) => s.isChecked).length == steps.length;
});

// * 监听激活的step，若是有音乐则默认播放音乐
watch(
  () => activeStep.value,
  (newVal: any) => {
    if (newVal.enableAudio) {
      if (newVal.audioOpt) {
        Object.entries(newVal.audioOpt).forEach(([key, value]) => {
          newVal.audio[key] = value;
        });
      }
      newVal.audio.play();
    }
  },
  {
    immediate: true,
  }
);

/**
 * 重置所有的step
 */
const resetSteps = () => {
  activeStepNum.value = 0;
  steps.forEach((step) => {
    step.isChecked = false;
    step.success = true;
    if (step.enableAudio) {
      step.audio.currentTime = 0;
      step.audio.pause();
    }
  });
  soundRecorder.value?.destroy();
  ElMessage({
    type: "info",
    center: true,
    message: "请按照屏幕提示，重新检测所有设备。",
  });
};

/**
 * 重置当前step
 */
const resetStep = async () => {
  activeStep.value.isChecked = false;
  activeStep.value.success = true;
  if (activeStep.value.enableAudio) {
    activeStep.value.audio.currentTime = 0;
    activeStep.value.audio.play();
  }
  // await soundRecorder.value?.destroy();
  // if (activeStepNum.value === 2) {
  //   soundRecorder.value?.startRecording();
  // }
  ElMessage({
    type: "info",
    center: true,
    message: "请按照屏幕提示，重新检测当前步骤。",
  });
};

/**
 * 正常，跳转下一个
 */
const correctCheck = () => {
  activeStep.value.isChecked = true;
  activeStep.value.success = true;
  if (activeStep.value.enableAudio) {
    activeStep.value.audio.currentTime = 0;
    activeStep.value.audio.pause();
  }
  activeStepNum.value += 1;
  if (isRecording.value) {
    soundRecorder.value?.stopRecording();
  }
};

/**
 * 错误，直接弹出
 */
const errorCheck = () => {
  activeStep.value.isChecked = true;
  activeStep.value.success = false;
  if (activeStep.value.enableAudio) {
    activeStep.value.audio.currentTime = 0;
    activeStep.value.audio.pause();
  }
  if (isRecording.value) {
    soundRecorder.value?.stopRecording();
  }
};

const systemVolumeSlider = ref<typeof ElSlider>();
const systemVolume = reactive({
  volume: 0,
  max: 1,
  min: 0,
});

watchEffect(() => {
  const vol = systemVolume.volume || 0;
  if (systemVolumeSlider.value) {
    const { slider } = systemVolumeSlider.value;
    slider.getElementsByClassName("el-slider__button")[0].innerHTML = `${vol}`;
    // )[0].innerHTML = `<span style="display: block;height: 46px;line-height: 46px;font-size: 24px;color: #FAFFFF;">${vol}</span>`;
  }
  setSystemVolume && setSystemVolume(vol);
});

// const changeVolumeView = function (volume: number) {
//   if (systemVolumeSlider.value) {
//     const { slider } = systemVolumeSlider.value;
//     slider.getElementsByClassName(
//       "el-slider__button"
//     )[0].innerHTML = `<span style="display: block;height: 46px;line-height: 46px;font-size: 24px;color: #FAFFFF;">${volume}</span>`;
//   }
// };

/**
 * 设置系统音量
 * @param volume 音量
 */
const setSystemVolume = _.throttle(
  async (volume: any) => {
    console.log(`设置系统音量:${volume}`);
    // await platform.setMuted(true);
    if (volume === 0) {
      await platform.setMuted(false);
    } else {
      await platform.setVolume(volume);
    }
    // changeVolumeView(volume);
  },
  500,
  { leading: true }
);

/**
 * 获取系统音量数据
 */
const getSystemVolume = async () => {
  const volume = await platform.getVolume();
  console.log(`获取系统音量:${volume}`);
  systemVolume.volume = volume || 60;
  systemVolume.min = 0;
  systemVolume.max = 100;
  // changeVolumeView(systemVolume.volume);
};

// * 录音相关
const soundRecorder = ref<SoundRecorder>();
const isRecordAudioPlaying = computed(() => soundRecorder.value?.audioPlaying);
const isRecording = computed(() => soundRecorder.value?.recording);

const soundRecordering = async () => {
  if (activeStep.value.enableAudio) {
    activeStep.value.audio.currentTime = 0;
    activeStep.value.audio.play();
  }
  if (isRecording.value) {
    await soundRecorder.value?.stopRecording();
  } else {
    if (isRecordAudioPlaying.value) {
      soundRecorder?.value?.pause();
    }
    await soundRecorder.value?.startRecording();
  }
};
const playSoundRecorder = async () => {
  if (soundRecorder.value && soundRecorder.value.audio && !isRecording.value) {
    if (isRecordAudioPlaying.value) {
      soundRecorder.value.pause();
    } else {
      soundRecorder.value.play();
    }
  } else {
    ElMessage({
      type: "info",
      center: true,
      message: "请先进行录音或结束录音。",
    });
  }
};

const mikeVolumeSlider = ref<typeof ElSlider>();
const mikeVolume = reactive({
  volume: 0,
  max: 1,
  min: 0,
});
watchEffect(() => {
  const vol = mikeVolume.volume || 0;
  if (mikeVolumeSlider.value) {
    const { slider } = mikeVolumeSlider.value;
    slider.getElementsByClassName(
      "el-slider__button"
    )[0].innerHTML = `<span style="display: block;height: 46px;line-height: 46px;font-size: 24px;color: #FAFFFF;">${vol}</span>`;
  }
  setMikeVolume && setMikeVolume(vol);
});

/**
 * 设置系统音量
 * @param volume 音量
 */
const setMikeVolume = (volume: any) => {
  // todo 需要根据不同平台设置系统音量
  if (window.require) {
    const { ipcRenderer } = window.require("electron");
    console.log("向electron发送信息", ipcRenderer);
    ipcRenderer.sendToHost("setVol", volume); // 向原生发送信息
  }
};

/**
 * 获取系统音量数据
 */
const getMikeVolume = () => {
  // todo 需要根据不同平台获取系统音量
  if (window.require) {
    const { ipcRenderer } = window.require("electron");
    ipcRenderer.on("getVol", (event: any, message: any) => {
      // 接收electron原生返回的信息
      console.log("我接收到的electron发过来的信息", event, message);
      mikeVolume.volume = message;
    });
  }
  mikeVolume.volume = mikeVolume.volume || 80;
  mikeVolume.min = 0;
  mikeVolume.max = 100;
};
const overType = ref<"goBack" | "goExam" | undefined>(undefined);

const goExam = () => {
  const exam_time_type = store.state.examInfo?.active_exam?.exam_time_type;
  const start_time = moment(store.state.examInfo?.active_exam?.start_time);
  console.log("start_time", start_time);
  console.log("moment", moment(new Date()));
  if (moment(new Date()).isAfter(start_time)) {
    router.push({
      path: "/paper",
    });
    return;
  }
  if (exam_time_type === 0) {
    router.push({
      path: "/unifiedMode",
    });
  } else {
    router.push({
      path: "/freeMode",
    });
  }
};
const goBack = () => {
  router.back();
};
onBeforeMount(async () => {
  // 判断是否为Android 是的话通知android隐藏悬浮球
  let isAndroid = true;
  const device = navigator.userAgent;
  isAndroid = device.indexOf("Android") > -1 || device.indexOf("Adr") > -1;
  if (isAndroid) {
    await platform.setOnExamEnter();
  }
});

onMounted(async () => {
  soundRecorder.value = new SoundRecorder();
  overType.value = (route.query.overType as any) || "goBack";
  await getSystemVolume();
  getMikeVolume();
  await platform.setMicVolume(90);
  ElLoadingService({ background: "rgb(0,0,0,0.0)" }).close();
  console.log("设置麦克风60");
});

onBeforeUnmount(() => {
  if (activeStep.value.enableAudio) {
    activeStep.value.audio.currentTime = 0;
    activeStep.value.audio.pause();
  }
  soundRecorder.value?.destroy();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(activeStep).title || ""), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ElSteps), {
          active: activeStepNum.value,
          "align-center": true,
          "finish-status": "success",
          class: "check-steps"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(steps), (step, index) => {
              return (_openBlock(), _createBlock(_unref(ElStep), {
                key: index,
                title: step.name,
                class: "check-step"
              }, null, 8, ["title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", {
            class: "check-area-item check-area-item_touch",
            onClick: correctCheck
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(activeStep).icon
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(activeStep).description), 1)
            ])
          ], 512), [
            [_vShow, _unref(activeStep).id === 1 && !_unref(checkError) && !_unref(allChecked)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _unref(activeStep).icon
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(activeStep).description), 1)
            ])
          ], 512), [
            [_vShow, _unref(activeStep).id === 2 && !_unref(checkError) && !_unref(allChecked)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                src: _unref(activeStep).icon
              }, null, 8, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(activeStep).description), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: "check-area_item_record",
                  onClick: soundRecordering
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: _normalizeClass(!_unref(isRecording) ? 'play' : 'pause')
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(!_unref(isRecording) ? "开始录音" : "结束录音"), 1)
                ]),
                _createElementVNode("div", {
                  class: "check-area_item_play",
                  onClick: playSoundRecorder
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(!_unref(isRecordAudioPlaying) ? 'play' : 'pause')
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(!_unref(isRecordAudioPlaying) ? "播放录音" : "停止播放"), 1)
                ])
              ])
            ])
          ], 512), [
            [_vShow, _unref(activeStep).id === 3 && !_unref(checkError) && !_unref(allChecked)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_25, _hoisted_28, 512), [
            [_vShow, _unref(checkError)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(`设备检测通过，请点击${
                    overType.value === "goBack" ? "上方" : "下方"
                  }按钮${overType.value === "goBack" ? "返回上层页面" : "进入测评"}`), 1)
            ])
          ], 512), [
            [_vShow, !_unref(checkError) && _unref(allChecked)]
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _withDirectives(_createElementVNode("div", _hoisted_34, [
            _createVNode(_unref(ElIcon), {
              size: 60,
              color: "#5bcd7c",
              class: "check-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                _unref(systemVolume).volume >= _unref(systemVolume).min && _unref(systemVolume).volume--
              ))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Remove))
              ]),
              _: 1
            }),
            _createVNode(_unref(ElSlider), {
              min: _unref(systemVolume).min,
              max: _unref(systemVolume).max,
              step: 5,
              "show-tooltip": false,
              ref_key: "systemVolumeSlider",
              ref: systemVolumeSlider,
              modelValue: _unref(systemVolume).volume,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(systemVolume).volume) = $event)),
              class: "headset-slider"
            }, null, 8, ["min", "max", "modelValue"]),
            _createVNode(_unref(ElIcon), {
              size: 60,
              color: "#5bcd7c",
              class: "check-icon",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
                _unref(systemVolume).volume < _unref(systemVolume).max && _unref(systemVolume).volume++
              ))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CirclePlus))
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _unref(activeStep).id === 2 && !_unref(checkError)]
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_35, [
        _withDirectives(_createVNode(_unref(ElButton), {
          size: "large",
          type: "danger",
          onClick: errorCheck
        }, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }, 512), [
          [_vShow, !_unref(checkError) && !_unref(allChecked)]
        ]),
        _withDirectives(_createVNode(_unref(ElButton), {
          size: "large",
          type: "success",
          onClick: correctCheck
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }, 512), [
          [_vShow, !_unref(checkError) && !_unref(allChecked)]
        ]),
        (
            (!_unref(activeStep).isChecked && _unref(activeStep).canAglinCheck) ||
            (_unref(checkError) && _unref(activeStep).errorAglinCheck)
          )
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              size: "large",
              type: "primary",
              onClick: resetStep
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(checkError) || _unref(allChecked))
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              size: "large",
              type: "primary",
              onClick: resetSteps,
              class: "recheck-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_39
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_unref(ElButton), {
          size: "large",
          type: "success",
          onClick: goExam
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }, 512), [
          [_vShow, !_unref(checkError) && _unref(allChecked) && overType.value === 'goExam']
        ])
      ], 512), [
        [_vShow, _unref(activeStep).id !== 1]
      ])
    ]),
    (overType.value === 'goBack')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "go-back",
          onClick: goBack
        }, [
          _createVNode(_unref(ElIcon), { size: 40 }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeftBold))
            ]),
            _: 1
          }),
          _hoisted_41
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})